<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconChromeLogo_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M14.023 4.432a.115.115 0 0 1-.099.173H8.306A3.408 3.408 0 0 0 4.7 7.15a.115.115 0 0 1-.21.029l-1.97-3.413a.115.115 0 0 1 .009-.13A6.97 6.97 0 0 1 8 1a6.995 6.995 0 0 1 6.023 3.432ZM8 10.616A2.619 2.619 0 0 1 5.384 8 2.62 2.62 0 0 1 8 5.384 2.619 2.619 0 0 1 10.616 8 2.619 2.619 0 0 1 8 10.616Zm1.034.709a.114.114 0 0 0-.121-.04 3.404 3.404 0 0 1-.913.124 3.426 3.426 0 0 1-3.091-1.973L2.098 4.567a.115.115 0 0 0-.2.001 7.004 7.004 0 0 0 5.058 10.355l.017.001c.04 0 .078-.021.099-.057l1.971-3.414a.115.115 0 0 0-.009-.128Zm1.431-5.954h3.946c.048 0 .09.029.107.073.32.814.482 1.674.482 2.556a6.957 6.957 0 0 1-2.024 4.924 6.957 6.957 0 0 1-4.897 2.075.115.115 0 0 1-.1-.172l2.816-4.877A3.384 3.384 0 0 0 11.409 8c0-.921-.364-1.785-1.024-2.432a.115.115 0 0 1 .08-.197Z"
        clip-rule="evenodd"
    />
</svg>
